import { render, staticRenderFns } from "./AangerEcharts.vue?vue&type=template&id=28f25ad6&scoped=true&"
import script from "./AangerEcharts.vue?vue&type=script&lang=js&"
export * from "./AangerEcharts.vue?vue&type=script&lang=js&"
import style0 from "./AangerEcharts.vue?vue&type=style&index=0&id=28f25ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f25ad6",
  null
  
)

export default component.exports